import clsx from 'clsx';
import * as React from 'react';
import { Icon } from '../Icon';
import useStyles from './CircleIcon.styles';

export interface ICircleIconProps {
  type: 'phone' | 'email';
}

const iconMap: Record<ICircleIconProps['type'], JSX.Element> = {
  phone: <Icon type="phone" />,
  email: <Icon type="mail" />,
};

const CircleIcon: React.FC<ICircleIconProps> = ({ type }) => {
  const classes = useStyles();
  const icon = iconMap[type];

  return <div className={clsx(classes.root, classes[type])}>{icon}</div>;
};

export default CircleIcon;
